export enum MutationType {
  SET_CURRENT_SCHEMA = 'setCurrentSchema',
  SET_SCHEMA_DRIS = 'setSchemaDRIs',
  SET_SCHEMA_DRI_TITLE = 'setSchemaDRITitle',
  SET_REPOS = 'setRepos',
  SET_VAULT_ITEMS = 'setVaultItems',
  SET_VAULT_ITEM = 'setVaultItem',
  SET_VAULT_ITEM_LANGUAGE = 'setVaultItemLanguage',
  SET_FETCH_STATE = 'setSchemaDRIFetchState',
  SET_VAULT_ITEMS_PAGING = 'setVaultItemsPaging',
  SET_UI_IS_FLUID = 'setUiIsFluid',
}
